import React, { useState, useEffect } from 'react';
import { Layout } from "./components/dashboard/layout";
import { Box, TextField, Typography, Button } from '@mui/material';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const ReportsOut = () => {
  const [logs, setLogs] = useState([]);
  const [reportLogs, setReportLogs] = useState([]);
  const [fromDate, setFromDate] = useState(new Date());
  const [toDate, setToDate] = useState(new Date());
  const [searchQuery, setSearchQuery] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const formatDate = (date) => {
    if (!date) return '';
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const fetchLogs = async () => {
    setIsLoading(true);
    try {
      const from = formatDate(fromDate);
      const to = formatDate(toDate);
      const search = encodeURIComponent(searchQuery);
      const url = 'https://raptornet.aischennai.org/screening-manager/gate-api/getCheckOutLogs.php?from_date='+from+'&to_date='+to+'&search='+search;

      const response = await fetch(url);
      const result = await response.json();

      if (result.success) {
        setLogs(result.data);
        setReportLogs(result.data);
      } else {
        setLogs([]);
        setReportLogs([]);
      }
    } catch (error) {
      console.error("Error fetching checkout logs:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, []);

  return (
    <Layout>
      <Box sx={{ p: 4 }}>
        <Typography variant="h4" gutterBottom>Reports</Typography>

        <Box sx={{ display: 'flex', gap: 2, mb: 3, alignItems: 'center' }}>
          <DatePicker
            selected={fromDate}
            onChange={(date) => setFromDate(date)}
            dateFormat="yyyy-MM-dd"
            customInput={<TextField variant="outlined" label="From Date" />}
          />
          <DatePicker
            selected={toDate}
            onChange={(date) => setToDate(date)}
            dateFormat="yyyy-MM-dd"
            customInput={<TextField variant="outlined" label="To Date" />}
          />
          <TextField
            label="Search by Name or ID"
            variant="outlined"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
          <Button variant="contained" onClick={fetchLogs}>Search</Button>
        </Box>

        <Box sx={{ mt: 3 }}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Date/Time</th>
                <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>ID</th>
                <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Name</th>
                <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Mode</th>
                <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Type</th>
                <th style={{ borderBottom: '1px solid #ddd', padding: '8px', textAlign: 'left' }}>Image</th>
              </tr>
            </thead>
            <tbody>
              {reportLogs.length === 0 ? (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '20px' }}>No logs found.</td>
                </tr>
              ) : (
                reportLogs.map((log, index) => (
                  <tr key={index}>
                    <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{log.datetime}</td>
                    <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{log.id}</td>
                    <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{log.name}</td>
                    <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{log.mode}</td>
                    <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>{log.action_type}</td>
                    <td style={{ borderBottom: '1px solid #ddd', padding: '8px' }}>
                      <img src={log.image_url} alt={log.id} width="50" height="50" />
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </Box>
      </Box>
    </Layout>
  );
};

export default ReportsOut;
